export const SIDEBAR_PINNED_STORAGE_KEY: string = 'sidebarExpansionPinned'
export const FAVOURITES_STORAGE_KEY: string = 'favourites'
export const DEFAULT_REPORTING_WIDTH: number = 400
export const SIDEBAR_WIDTH_COLLAPSED: number = 50
export const SIDEBAR_WIDTH_EXPANDED: number = 240
export const REPORTING_MIN_WIDTH: number = 300

export enum SidebarMenuItems {
    REPORTING = 'REPORTING',
    INSIGHTS = 'INSIGHTS',
    PRESENCE = 'PRESENCE',
    USER_MANAGEMENT = 'USER_MANAGEMENT',
    QUEUE_MANAGEMENT = 'QUEUE_MANAGEMENT',
    SELF_PROVISIONING = 'SELF_PROVISIONING',
    CME = 'CME',
    TEL_SERVERS = 'TEL_SERVERS',
    PARTITIONS = 'PARTITIONS',
    USERS = 'USERS',
    DEVICES = 'DEVICES',
    AGENTS = 'AGENTS',
    DIRECTORY = 'DIRECTORY',
    CODES = 'CODES',
    RECORDINGS = 'RECORDINGS',
    MESSAGE = 'MESSAGE',
    DATABASE = 'DATABASE',
    LICENCES = 'LICENCES',
    LOGGING = 'LOGGING',
    LOG_MANAGEMENT = 'LOG_MANAGEMENT',
    AUDIT_LOGS = 'AUDIT_LOGS',
    TELEPHONY_MODULES_STATUS = 'TELEPHONY_MODULES_STATUS',
    CALL_CONTROL = 'CALL_CONTROL',
    SERVER_STATUS = 'SERVER_STATUS'
}
